module.exports = __webpack_public_path__ + "portal-static/img/no_math1.a7b4a9a2.png";